import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import { API_URL } from "../../../../utils/apiRoutes";
import { commonService } from "../../../../utils/commonService";
import Comments from "../Comments/Comment";
import { Button, Overlay, OverlayTrigger, Popover, Row, Table, Form } from "react-bootstrap";
import emailIcon from "../../../../Assets/Images/Email.svg";
import { useParams } from "react-router-dom";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import { compName, month } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import moment from "moment";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { MultiSelect } from "primereact/multiselect";
import Loader from "../../../Loader/Loader";
import filter from "../../../../Assets/Images/Configuration/filter-icon.svg";
import Filter_MonthDowRoomTypeRatePlanChannels from "./Models/Filter_MonthDowRoomTypeRatePlanChannels";
const RNXSOTMPickup_CurrentYear = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
    topfilterdata,
    topviewoption
}) => {
    const [viewOption, setViewOption] = useState("Graph");

    useEffect(() => {
        if (topviewoption) {
            setViewOption(topviewoption)
        }
    }, [topviewoption]);

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => { setWidgetModal(false); };

    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const defaultAsOfDateFromRTK = useSelector((store) => store.headerProperty.defaultAsOfDate);

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
        id2: commonService.GenerateGUID(),
        id3: commonService.GenerateGUID(),
        id4: commonService.GenerateGUID(),
    });

    const [filterData, setFilterData] = useState({ year: new Date().getFullYear(), months: [], dow: [], ratecodes: [], roomtypes: [], combinedchannels: [] });

    const [CurrentYearData, setCurrentYearData] = useState([]);

    const [CurrentYearThisMonthData, setCurrentYearThisMonthData] = useState([]);

    const [LastYearData, setLastYearData] = useState([]);

    const [FinalData, setFinalData] = useState([]);

    const GetCurrentYearData = async () => {
        setCurrentYearData([]);
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_MONTH_WISE_SUMMARY_SOTM,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        year: filterData.year,
                        months: filterData.months ? filterData.months.map(item => item.code) : [],
                        daysofweek: filterData.dow ? filterData.dow.map(item => item.code) : [],
                        ratecodes: filterData.ratecodes ? filterData.ratecodes.map(item => item.code) : [],
                        roomtypes: filterData.roomtypes ? filterData.roomtypes.map(item => item.code) : [],
                        channels: filterData.combinedchannels ? filterData.combinedchannels.map(item => item.code) : [],
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setCurrentYearData(response?.data?.data);
            }
        } catch (error) {

        }
    };

    const GetCurrentYearThisMonthData = async () => {
        setCurrentYearThisMonthData([]);
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_MONTH_WISE_SUMMARY,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        year: filterData.year,
                        months: filterData.months ? filterData.months.map(item => item.code) : [],
                        daysofweek: filterData.dow ? filterData.dow.map(item => item.code) : [],
                        ratecodes: filterData.ratecodes ? filterData.ratecodes.map(item => item.code) : [],
                        roomtypes: filterData.roomtypes ? filterData.roomtypes.map(item => item.code) : [],
                        channels: filterData.combinedchannels ? filterData.combinedchannels.map(item => item.code) : [],
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setCurrentYearThisMonthData(response?.data?.data);
            }
        } catch (error) {

        }
    };

    const GetLastYearData = async () => {
        setLastYearData([]);
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot +
                        API_URL.RNX.RNX_MONTH_WISE_SUMMARY,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        year: filterData.year,
                        months: filterData.months ? filterData.months.map(item => item.code) : [],
                        daysofweek: filterData.dow ? filterData.dow.map(item => item.code) : [],
                        ratecodes: filterData.ratecodes ? filterData.ratecodes.map(item => item.code) : [],
                        roomtypes: filterData.roomtypes ? filterData.roomtypes.map(item => item.code) : [],
                        channels: filterData.combinedchannels ? filterData.combinedchannels.map(item => item.code) : [],
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setLastYearData(response?.data?.data);
            }
        } catch (error) {

        }
    };

    const [dataLoading, setDataLoading] = useState(false);

    const GetAllData = async () => {
        setDataLoading(true);
        await GetCurrentYearData();
        await GetCurrentYearThisMonthData();
        await GetLastYearData();
        setDataLoading(false);
    };

    useEffect(() => {
        if (api === 0) {
            const monthData = month.map(m => ({
                month: m,

                currentyearsotmroom: 0,
                currentyearsotmadr: 0,
                currentyearsotmrev: 0,

                currentyearthismonthroom: 0,
                currentyearthismonthroomdiff: 0,
                currentyearthismonthadr: 0,
                currentyearthismonthadrdiff: 0,
                currentyearthismonthrev: 0,
                currentyearthismonthrevdiff: 0,

                pastyearroom: 0,
                pastyearroomdiff: 0,
                pastyearadr: 0,
                pastyearadrdiff: 0,
                pastyearrev: 0,
                pastyearrevdiff: 0,


            }));

            const totalRow = {
                month: "Total",

                currentyearsotmroom: 0,
                currentyearsotmadr: 0,
                currentyearsotmrev: 0,

                currentyearthismonthroom: 0,
                currentyearthismonthroomdiff: 0,
                currentyearthismonthadr: 0,
                currentyearthismonthadrdiff: 0,
                currentyearthismonthrev: 0,
                currentyearthismonthrevdiff: 0,

                pastyearroom: 0,
                pastyearroomdiff: 0,
                pastyearadr: 0,
                pastyearadrdiff: 0,
                pastyearrev: 0,
                pastyearrevdiff: 0,
            };

            setFinalData([...monthData, totalRow]);
        } else {
            if (para?.asOfDate) {
                GetAllData();
            }
        }
    }, [para?.asOfDate, filterData]);

    useEffect(() => {
        if (topfilterdata) {
            setFilterData(topfilterdata)
        }
    }, [topfilterdata]);

    useEffect(() => {
        if (!dataLoading) {
            let _FinalData = [];
            const totalRow = {
                month: "Total",
                currentyearsotmroom: 0,
                currentyearsotmadr: 0,
                currentyearsotmrev: 0,

                currentyearthismonthroom: 0,
                currentyearthismonthroomdiff: 0,
                currentyearthismonthadr: 0,
                currentyearthismonthadrdiff: 0,
                currentyearthismonthrev: 0,
                currentyearthismonthrevdiff: 0,

                pastyearroom: 0,
                pastyearroomdiff: 0,
                pastyearadr: 0,
                pastyearadrdiff: 0,
                pastyearrev: 0,
                pastyearrevdiff: 0,
            };

            month.map((m) => {
                let currentyearsotmroom = 0,
                    currentyearsotmadr = 0,
                    currentyearsotmrev = 0,

                    currentyearthismonthroom = 0,
                    currentyearthismonthroomdiff = 0,
                    currentyearthismonthadr = 0,
                    currentyearthismonthadrdiff = 0,
                    currentyearthismonthrev = 0,
                    currentyearthismonthrevdiff = 0,

                    pastyearroom = 0,
                    pastyearroomdiff = 0,
                    pastyearadr = 0,
                    pastyearadrdiff = 0,
                    pastyearrev = 0,
                    pastyearrevdiff = 0;

                let CD = CurrentYearData.filter((d) => d.monthname.toUpperCase() === m.substr(0, 3).toUpperCase())

                if (CD && CD.length > 0) {
                    currentyearsotmroom = CD[0].total_roomnights ? parseInt(CD[0].total_roomnights) : 0;
                    currentyearsotmadr = CD[0].adr ? parseInt(CD[0].adr) : 0;
                    currentyearsotmrev = CD[0].total_revenue ? parseInt(CD[0].total_revenue) : 0;

                }

                let CMD = CurrentYearThisMonthData.filter((d) => d.monthname.toUpperCase() === m.substr(0, 3).toUpperCase())

                if (CMD && CMD.length > 0) {
                    currentyearthismonthroom = CMD[0].total_roomnights ? parseInt(CMD[0].total_roomnights) : 0;
                    currentyearthismonthroomdiff = commonService.GrowthDiifValue(currentyearthismonthroom, currentyearsotmroom);
                    currentyearthismonthadr = CMD[0].adr ? parseInt(CMD[0].adr) : 0;
                    currentyearthismonthadrdiff = commonService.GrowthDiifValue(currentyearthismonthadr, currentyearsotmadr);
                    currentyearthismonthrev = CMD[0].total_revenue ? parseInt(CMD[0].total_revenue) : 0;
                    currentyearthismonthrevdiff = commonService.GrowthDiifValue(currentyearthismonthrev, currentyearsotmrev);
                }


                let LD = LastYearData.filter((d) => d.monthname.toUpperCase() === m.substr(0, 3).toUpperCase())

                if (LD && LD.length > 0) {
                    pastyearroom = LD[0].lastyear_total_roomnights ? parseInt(LD[0].lastyear_total_roomnights) : 0;
                    pastyearroomdiff = commonService.GrowthDiifValue(pastyearroom, currentyearsotmroom);
                    pastyearadr = LD[0].lastyear_adr ? parseInt(LD[0].lastyear_adr) : 0;
                    pastyearadrdiff = commonService.GrowthDiifValue(pastyearadr, currentyearsotmadr);
                    pastyearrev = LD[0].lastyear_total_revenue ? parseInt(LD[0].lastyear_total_revenue) : 0;
                    pastyearrevdiff = commonService.GrowthDiifValue(pastyearrev, currentyearsotmrev);
                }

                _FinalData.push({
                    month: m,
                    currentyearsotmroom: currentyearsotmroom,
                    currentyearsotmadr: currentyearsotmadr,
                    currentyearsotmrev: currentyearsotmrev,

                    currentyearthismonthroom: currentyearthismonthroom,
                    currentyearthismonthroomdiff: currentyearthismonthroomdiff,
                    currentyearthismonthadr: currentyearthismonthadr,
                    currentyearthismonthadrdiff: currentyearthismonthadrdiff,
                    currentyearthismonthrev: currentyearthismonthrev,
                    currentyearthismonthrevdiff: currentyearthismonthrevdiff,

                    pastyearroom: pastyearroom,
                    pastyearroomdiff: pastyearroomdiff,
                    pastyearadr: pastyearadr,
                    pastyearadrdiff: pastyearadrdiff,
                    pastyearrev: pastyearrev,
                    pastyearrevdiff: pastyearrevdiff,
                });

                totalRow.currentyearsotmroom += currentyearsotmroom;
                totalRow.currentyearsotmrev += currentyearsotmrev;
                totalRow.currentyearsotmadr = totalRow.currentyearsotmrev !== 0 && totalRow.currentyearsotmroom !== 0 ? parseInt(totalRow.currentyearsotmrev / totalRow.currentyearsotmroom) : 0;

                totalRow.currentyearthismonthroom += currentyearthismonthroom;
                totalRow.currentyearthismonthroomdiff = commonService.GrowthDiifValue(totalRow.currentyearthismonthroom, totalRow.currentyearsotmroom);

                totalRow.currentyearthismonthrev += currentyearthismonthrev;
                totalRow.currentyearthismonthrevdiff = commonService.GrowthDiifValue(totalRow.currentyearthismonthrev, totalRow.currentyearsotmrev);

                totalRow.currentyearthismonthadr = totalRow.currentyearthismonthrev !== 0 && totalRow.currentyearthismonthroom !== 0 ? parseInt(totalRow.currentyearthismonthrev / totalRow.currentyearthismonthroom) : 0;
                totalRow.currentyearthismonthadrdiff = commonService.GrowthDiifValue(totalRow.currentyearthismonthadr, totalRow.currentyearsotmadr);


                totalRow.pastyearroom += pastyearroom;
                totalRow.pastyearroomdiff = commonService.GrowthDiifValue(totalRow.pastyearroom, totalRow.currentyearsotmroom);

                totalRow.pastyearrev += pastyearrev;
                totalRow.pastyearrevdiff = commonService.GrowthDiifValue(totalRow.pastyearrev, totalRow.currentyearsotmrev);

                totalRow.pastyearadr = totalRow.pastyearrev !== 0 && totalRow.pastyearroom !== 0 ? parseInt(totalRow.pastyearrev / totalRow.pastyearroom) : 0;
                totalRow.pastyearadrdiff = commonService.GrowthDiifValue(totalRow.pastyearadr, totalRow.currentyearsotmadr);
            });

            _FinalData.push(totalRow);
            setFinalData(_FinalData);
        }
    }, [dataLoading]);

    let AllWidgetContainer = document.getElementById(
        "RNXSOTMPickup_CurrentYear"
    );

    if (AllWidgetContainer !== null) {
        let CW = AllWidgetContainer.clientWidth;
        CW = CW - 120;
        CW = Math.round(CW / 3);
        if (CW < 250) {
            CW = 250;
        }
        let Widget = AllWidgetContainer.getElementsByClassName(
            "allTableTogather-widget"
        );
        if (Widget !== null && Widget.length !== 0) {
            for (let i = 0; i < Widget.length; i++) {
                Widget[i].style.width = CW + "px";
            }
        }
    }

    const [DisplayFilter, setDisplayFilter] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });

    const ShowFilter = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setDisplayFilter({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const CloseFilter = (data) => {
        setDisplayFilter({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
        setFilterData(data)
    };

    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.id2} .perbackground-rev`
    );

    return (
        <div
            className="widget-container"
            style={{ position: "relative", padding: "0 5px" }}
        >
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">

                    {
                        !topfilterdata &&
                        <Button id={commonService.generateGlobalClickTrackerID("RNXSOTMPickup_CurrentYear", "filter", propertyCode)} className="heading-menu-btns" type="button" title="Filter"
                            onClick={(e) => {
                                ShowFilter(e);
                            }}>
                            <img
                                src={filter}
                                alt="Filter"
                            />
                        </Button>
                    }

                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("RNXSOTMPickup_CurrentYear", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.id1 +
                                    "," +
                                    tblids.id2 +
                                    "," +
                                    tblids.id3 +
                                    "," +
                                    tblids.id4,
                                    "Snapshot By Month",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RNXSOTMPickup_CurrentYear", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.annualSummary,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RNXSOTMPickup_CurrentYear", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={
                                tblids.id1 +
                                "," +
                                tblids.id2 +
                                "," +
                                tblids.id3 +
                                "," +
                                tblids.id4
                            }
                            onClick={() => {
                                commonService.fnExportInCSV(
                                    tblids.id1 +
                                    "," +
                                    tblids.id2 +
                                    "," +
                                    tblids.id3 +
                                    "," +
                                    tblids.id4,
                                    `${para?.propertyCode}-Annual Summary-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                );
                            }}
                        />
                    </Button>

                    {
                        DisplayFilter.IsDisplay &&
                        <Overlay
                            show={DisplayFilter.IsDisplay}
                            target={DisplayFilter.Target}
                            placement={DisplayFilter.Position}
                        >
                            <Popover
                                id="popover-contained"
                                className="FilterPopover"
                            >
                                <Filter_MonthDowRoomTypeRatePlanChannels show={DisplayFilter.IsDisplay} closeModal={CloseFilter} para={para} dropdownSelectedData={filterData} />
                            </Popover>
                        </Overlay>
                    }

                </div>
            )}
            <div className="allTableTogatherWrapper" id="RNXSOTMPickup_CurrentYear">
                <div style={{ display: "flex", gridGap: "10px" }}>
                    <div style={{ width: "120px", flex: "none" }}>
                        <div className="ViewPropertySetupTable monthSelectTable">
                            <div className="stripped__table">
                                <Table id={tblids.id1} responsive>
                                    <thead>
                                        <tr>
                                            <th>

                                            </th>
                                        </tr>
                                        <tr>
                                            <th>

                                            </th>
                                        </tr>
                                        <tr>
                                            <th>Month</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            dataLoading ?
                                                <tr
                                                    style={{
                                                        height: "80px",
                                                        position: "relative",
                                                    }}
                                                >
                                                    <Loader />
                                                </tr>
                                                :
                                                <>
                                                    {month?.map((item, index) => (
                                                        <tr key={item}>
                                                            <td>{item}</td>
                                                        </tr>
                                                    ))}
                                                    <tr>
                                                        <td className="boldTd">Total</td>
                                                    </tr>
                                                </>
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive" style={{ flex: "1" }}>
                        <div
                            className="allTableTogather"
                            style={{ display: "flex", gridGap: "10px" }}
                        >
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable">
                                    <div className="stripped__table">
                                        <Table id={tblids.id2} responsive>
                                            <thead>
                                                <tr>
                                                    <th colSpan={3} className={"text-center"}>{filterData.year}</th>
                                                </tr>
                                                <tr>
                                                    <th colSpan={3} className={"text-center"}>SOTM</th>
                                                </tr>
                                                <tr>
                                                    <th>ROOMS</th>
                                                    <th className={"text-end"}>ADR</th>
                                                    <th className={"text-end"}>REV</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dataLoading ?
                                                        <tr
                                                            style={{
                                                                height: "80px",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <Loader />
                                                        </tr>
                                                        :
                                                        <>
                                                            {FinalData?.map((item, index) => (
                                                                <tr>
                                                                    <td className={` ${item.month === "Total" ? "boldTd" : ""}`}>{item.currentyearsotmroom}</td>
                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.currentyearsotmadr)}</td>
                                                                    <td className={` text-end ${item.month === "Total" ? "boldTd" : "perbackground perbackground-rev"}`} value={item.currentyearsotmrev}>{commonService.formateAmount(item.currentyearsotmrev)}</td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable">
                                    <div className="stripped__table">
                                        <Table id={tblids.id3} responsive>
                                            <thead>
                                                <tr>
                                                    <th colSpan="6" className={"text-center"}>
                                                        {filterData.year}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="6" className={"text-center"}>
                                                        THIS MONTH
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="2">ROOMS</th>
                                                    <th colSpan="2" className={"text-center"}>ADR</th>
                                                    <th colSpan="2" className={"text-center"}>REV</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dataLoading ?
                                                        <tr
                                                            style={{
                                                                height: "80px",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <Loader />
                                                        </tr>
                                                        :
                                                        <>
                                                            {FinalData?.map((item, index) => (
                                                                <tr>
                                                                    <td className={` ${item.month === "Total" ? "boldTd" : ""}`}>{item.currentyearthismonthroom}</td>
                                                                    <td className={`text-center ${item.month === "Total" ? "boldTd" : ""} ${item.currentyearthismonthroomdiff !== 0 ? item.currentyearthismonthroomdiff > 0 ? "greenText" : "redText" : ""}`}>{item.currentyearthismonthroomdiff}</td>
                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.currentyearthismonthadr)}</td>
                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""} ${item.currentyearthismonthadrdiff !== 0 ? item.currentyearthismonthadrdiff > 0 ? "greenText" : "redText" : ""}`}>{commonService.formateAmount(item.currentyearthismonthadrdiff)}</td>
                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.currentyearthismonthrev)}</td>
                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""} ${item.currentyearthismonthrevdiff !== 0 ? item.currentyearthismonthrevdiff > 0 ? "greenText" : "redText" : ""}`}>{commonService.formateAmount(item.currentyearthismonthrevdiff)}</td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                }

                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable">
                                    <div className="stripped__table">
                                        <Table id={tblids.id4} responsive>
                                            <thead>
                                                <tr>
                                                    <th colSpan="6" className={"text-center"}>
                                                        {filterData.year - 1}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="6" className={"text-center"}>
                                                        PAST YEAR
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="2">ROOMS</th>
                                                    <th colSpan="2" className={"text-center"}>ADR</th>
                                                    <th colSpan="2" className={"text-center"}>REV</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dataLoading ?
                                                        <tr
                                                            style={{
                                                                height: "80px",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <Loader />
                                                        </tr>
                                                        :
                                                        <>
                                                            {FinalData?.map((item, index) => (
                                                                <tr>
                                                                    <td className={` ${item.month === "Total" ? "boldTd" : ""}`}>{item.pastyearroom}</td>
                                                                    <td className={`text-center ${item.month === "Total" ? "boldTd" : ""} ${item.pastyearroomdiff !== 0 ? item.pastyearroomdiff > 0 ? "greenText" : "redText" : ""}`}>{item.pastyearroomdiff}
                                                                    </td>

                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.pastyearadr)}</td>
                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""} ${item.pastyearadrdiff !== 0 ? item.pastyearadrdiff > 0 ? "greenText" : "redText" : ""}`}>{commonService.formateAmount(item.pastyearadrdiff)}</td>
                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.pastyearrev)}</td>
                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""} ${item.pastyearrevdiff !== 0 ? item.pastyearrevdiff > 0 ? "greenText" : "redText" : ""}`}>{commonService.formateAmount(item.pastyearrevdiff)}</td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            {api !== 0 && !topfilterdata && (
                <Comments widgetDetails={para} editorId={"editor" + tblids.id1} />
            )}
        </div>
    );
};

export default RNXSOTMPickup_CurrentYear;